import { createAsyncThunk } from '@reduxjs/toolkit';
import {
  getConnectwisePodDataByProjectTicketId,
  getConnectwisePodDataByTicketId,
} from 'services/pod';
import { IPodData } from 'services/pod/types';

interface IProps {
  psaId: number;
  ticketId: number;
}

export const ThunkGetConnectwisePodData = createAsyncThunk<IPodData, IProps>(
  'pod/getCWPodData',
  async ({ psaId, ticketId }) => {
    const { data } = await getConnectwisePodDataByTicketId(psaId, ticketId);
    return data;
  },
);

export const ThunkGetConnectwisePodDataByProjectTicketId = createAsyncThunk<IPodData, IProps>(
  'pod/getCWPodDataByProjectTicketId',
  async ({ psaId, ticketId }) => {
    const { data } = await getConnectwisePodDataByProjectTicketId(psaId, ticketId);
    return data;
  },
);
